// SEO / JSON-LD for the Contact page.
// Kept separate from the page component so route `head()` can import this
// lightweight data without pulling the heavy page module into the main bundle.
export const contactJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'ContactPage',
  '@id': 'https://digitallybaffled.com/contact#webpage',
  name: 'Contact Us — Digitally Baffled',
  url: 'https://digitallybaffled.com/contact',
  description: 'Get in touch with Digitally Baffled by phone, email, WhatsApp, or social media.',
  isPartOf: { '@id': 'https://digitallybaffled.com/#website' },
  about: { '@id': 'https://digitallybaffled.com/#organization' },
  mainEntity: {
    '@type': ['Organization', 'ProfessionalService'],
    '@id': 'https://digitallybaffled.com/#organization',
    name: 'Digitally Baffled LTD',
    legalName: 'Digitally Baffled LTD',
    url: 'https://digitallybaffled.com',
    telephone: '+447511683542',
    email: 'hello@digitallybaffled.com',
    identifier: [{ '@type': 'PropertyValue', name: 'Companies House Number', value: '17238376' }],
    address: { '@type': 'PostalAddress', streetAddress: '18 Charing Close', addressLocality: 'Ringwood', postalCode: 'BH24 1FA', addressCountry: 'GB' },
    areaServed: { '@type': 'Country', name: 'United Kingdom' },
    sameAs: [
      'https://www.linkedin.com/company/119624069',
      'https://www.instagram.com/digitally_baffled',
      'https://www.facebook.com/share/1D8QbXPZuP/',
      'https://www.tiktok.com/@digitally_baffled',
      'https://x.com/DigitalBaffled',
    ],
  },
};
